import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import useCustomFecthQuery from "../../../../Hooks/useCustomFecthQuery";
import useCustomMutation from "../../../../Hooks/useCustomMutation";
import ViewSponsor from "./ViewSponsor";
import EditSponsor from "./EditSponsor";
import ModalDelete from "../../../Modal/ModalDelete";
import DeleteForm from "./DeleteForm";
import OffCanvas from "../../../OffCanvas/OffCanvas";
import { FaEdit } from "react-icons/fa";
import { AiFillEye, AiFillDelete } from "react-icons/ai";
import { Spinner } from "reactstrap";

const TableSponsor = ({ userID, token, eventID, search }) => {
  const [sponsorID, setSponsorID] = useState(false);
  const [sponsorDetails, setSponsorDetails] = useState(null);
  const [isToggleView, setIsToggleView] = useState(false);
  const [isToggleEdit, setIsToggleEdit] = useState(false);
  const [isToggleDelete, setIsToggleDelete] = useState(false);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);
  const key = ["mySponsors", eventID];

  const mutationDelete = useCustomMutation(key);

  const {
    data: getSponsors,
    error: errorGetSponsors,
    isLoading: isLoadingGetSponsors,
  } = useCustomFecthQuery(
    key,
    `${process.env.REACT_APP_API}sponsors/event/${eventID}`,
    token,
    {
      enabled: !!eventID,
    }
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth < 768;
  const isSmallMobile = windowWidth < 400;

  const tog_viewSponsor = (details) => {
    setSponsorDetails(details);
    setIsToggleView(!isToggleView);
  };
  
  const tog_editSponsor = (details) => {
    setSponsorDetails(details);
    setIsToggleEdit(!isToggleEdit);
  };
  
  const tog_deleteSponsor = (id) => {
    setSponsorID(id);
    setIsToggleDelete(!isToggleDelete);
  };

  const DeleteSponsor = () => {
    const Method = "DELETE",
      url = `sponsors/${sponsorID}`,
      isJSON = null;
    var raw = null;
    const data = {
      endPoint: url,
      bodyContent: raw,
      Method: Method,
      displayMessage: "Sponsor successfully deleted",
      token: token,
      isJSON: isJSON,
    };
    mutationDelete.mutate(data);
  };

  const filterParticipants = (sponsors, searchQuery) => {
    if (!searchQuery || !sponsors) return sponsors || [];
    return sponsors?.filter((item) =>
      [item?.sponsorName].some((field) =>
        field?.toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  };
  
  const filteredSponsors = filterParticipants(getSponsors?.data, search);
  const data = filteredSponsors || [];

  useEffect(() => {
    if (mutationDelete.isSuccess) {
      setIsToggleDelete(false);
    }
  }, [mutationDelete.isSuccess]);

  const customStyles = {
    tableWrapper: {
      style: {
        width: '100%',
        overflowX: 'auto',
        WebkitOverflowScrolling: 'touch',
      },
    },
    headRow: {
      style: {
        backgroundColor: '#f8f9fa',
        borderBottomWidth: '2px',
        borderBottomColor: '#e9ecef',
        minHeight: '48px',
      },
    },
    headCells: {
      style: {
        fontSize: '12px',
        fontWeight: '700',
        color: '#495057',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        paddingLeft: '12px',
        paddingRight: '12px',
        whiteSpace: 'nowrap',
      },
    },
    cells: {
      style: {
        fontSize: '13px',
        color: '#212529',
        paddingLeft: '12px',
        paddingRight: '12px',
        minHeight: '60px',
      },
    },
    rows: {
      style: {
        '&:hover': {
          backgroundColor: '#f8f9fa',
        },
        borderBottomWidth: '1px',
        borderBottomColor: '#e9ecef',
      },
    },
    pagination: {
      style: {
        backgroundColor: '#ffffff',
        borderTopWidth: '1px',
        borderTopColor: '#e9ecef',
        minHeight: '52px',
        fontSize: '13px',
      },
    },
  };

  const columns = [
    {
      name: <span>Logo</span>,
      cell: (row) => {
        const imageSize = isMobile ? (isSmallMobile ? 50 : 60) : 80;
        return (
          <div style={{ 
            display: 'flex', 
            alignItems: 'center',
            padding: '8px 0'
          }}>
            <div style={{ 
              width: imageSize, 
              height: imageSize, 
              borderRadius: '10px',
              overflow: 'hidden',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              flexShrink: 0,
            }}>
              <img
                src={row?.logo}
                alt="sponsor-logo"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </div>
          </div>
        );
      },
      minWidth: isMobile ? '100px' : '120px',
      maxWidth: isMobile ? '120px' : '140px',
    },
    {
      name: <span>Sponsor Name</span>,
      selector: (row) => row?.sponsorName || 'N/A',
      sortable: true,
      grow: 2,
      style: {
        fontWeight: '600',
        fontSize: '14px',
      },
      cell: (row) => (
        <div style={{ 
          overflow: 'hidden', 
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          paddingRight: '8px'
        }} title={row?.sponsorName}>
          {row?.sponsorName || 'N/A'}
        </div>
      ),
    },
    {
      name: <span>Actions</span>,
      cell: (row) => {
        const buttonSize = isMobile ? 36 : 40;
        const iconSize = isMobile ? 16 : 18;
        
        return (
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: isMobile ? '6px' : '8px',
            flexWrap: isMobile ? 'wrap' : 'nowrap',
          }}>
            <button
              onClick={() => tog_viewSponsor(row)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: buttonSize,
                height: buttonSize,
                background: '#0d6efd',
                color: '#ffffff',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 4px rgba(13, 110, 253, 0.3)',
              }}
              title="View Sponsor"
            >
              <AiFillEye size={iconSize} />
            </button>
            
            <button
              onClick={() => tog_editSponsor(row)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: buttonSize,
                height: buttonSize,
                background: '#ffc107',
                color: '#000000',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 4px rgba(255, 193, 7, 0.3)',
              }}
              title="Edit Sponsor"
            >
              <FaEdit size={iconSize} />
            </button>

            <button
              onClick={() => tog_deleteSponsor(row?._id)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: buttonSize,
                height: buttonSize,
                background: '#dc3545',
                color: '#ffffff',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 4px rgba(220, 53, 69, 0.3)',
              }}
              title="Delete Sponsor"
            >
              <AiFillDelete size={iconSize} />
            </button>
          </div>
        );
      },
      center: true,
      minWidth: isMobile ? '140px' : '180px',
    },
  ];

  return (
    <div style={styles.container}>
      {isLoadingGetSponsors ? (
        <div style={styles.loadingState}>
          <Spinner color="primary" size="sm" />
          <p style={styles.loadingText}>Loading sponsors...</p>
        </div>
      ) : errorGetSponsors ? (
        <div style={styles.errorState}>
          <div style={styles.errorIcon}>⚠️</div>
          <p style={styles.errorText}>Error loading sponsors</p>
        </div>
      ) : data.length === 0 ? (
        <div style={styles.emptyState}>
          <div style={styles.emptyIcon}>📭</div>
          <h4 style={styles.emptyTitle}>No sponsors found</h4>
          <p style={styles.emptyText}>
            {search ? `No results for "${search}"` : 'Start by adding your first sponsor'}
          </p>
        </div>
      ) : (
        <div style={styles.tableWrapper}>
          <DataTable
            columns={columns}
            data={data}
            responsive
            pagination
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 25, 50]}
            customStyles={customStyles}
            highlightOnHover
            noDataComponent={
              <div style={styles.noData}>No records to display</div>
            }
          />
        </div>
      )}

      <ModalDelete
        size="md"
        isOpen={isToggleDelete}
        toggle={() => {
          setIsToggleDelete(false);
        }}
        title="Delete Sponsor"
        body={
          <DeleteForm
            setIsToggleDelete={setIsToggleDelete}
            DeleteParticitant={DeleteSponsor}
            pending={mutationDelete?.isLoading}
          />
        }
      />
      
      <OffCanvas
        isOffcanvasOpen={isToggleView}
        title="Sponsor Details"
        body={<ViewSponsor details={sponsorDetails} />}
        toggleSaveChanges={() => tog_viewSponsor()}
        directionOffCanvas="end"
        widthOffCanvas={isMobile ? '100%' : 400}
      />
      
      <OffCanvas
        isOffcanvasOpen={isToggleEdit}
        title="Edit Sponsor"
        body={
          <EditSponsor
            details={sponsorDetails}
            setIsOffcanvasOpen={setIsToggleEdit}
            eventID={eventID}
            token={token}
          />
        }
        toggleSaveChanges={() => tog_editSponsor()}
        directionOffCanvas="end"
        widthOffCanvas={isMobile ? '100%' : 700}
      />

      <style>{`
        @media (max-width: 768px) {
          .sponsor-table-container {
            padding: 8px !important;
          }
        }

        @media (max-width: 480px) {
          .sponsor-table-container {
            padding: 4px !important;
          }
        }
      `}</style>
    </div>
  );
};

const styles = {
  container: {
    width: '100%',
    maxWidth: '100%',
    padding: '16px',
    boxSizing: 'border-box',
    backgroundColor: '#ffffff',
    borderRadius: '10px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    border: '1px solid #e9ecef',
  },
  loadingState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '60px 20px',
    minHeight: '250px',
    gap: '12px',
  },
  loadingText: {
    margin: 0,
    color: '#6c757d',
    fontSize: '14px',
  },
  errorState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '60px 20px',
    minHeight: '250px',
    textAlign: 'center',
  },
  errorIcon: {
    fontSize: '48px',
    marginBottom: '12px',
  },
  errorText: {
    margin: 0,
    color: '#dc3545',
    fontSize: '14px',
    fontWeight: '500',
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '60px 20px',
    minHeight: '250px',
    textAlign: 'center',
  },
  emptyIcon: {
    fontSize: '48px',
    marginBottom: '16px',
  },
  emptyTitle: {
    margin: '0 0 8px 0',
    fontSize: '18px',
    fontWeight: '600',
    color: '#212529',
  },
  emptyText: {
    margin: 0,
    fontSize: '14px',
    color: '#6c7280',
  },
  tableWrapper: {
    width: '100%',
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '8px',
  },
  noData: {
    padding: '40px 20px',
    textAlign: 'center',
    color: '#6c757d',
    fontSize: '14px',
  },
};

export default TableSponsor;